import { Link } from "react-router-dom";

const base =
  "group inline-flex items-center gap-3 px-7 py-4 text-sm font-semibold tracking-wide transition-[background-color,box-shadow,color,border-color] duration-300 font-display";

export const CTA = ({ to = "/contact", href, children = "Talk to Krimzon", testId, variant = "crimson", type, onClick, disabled }) => {
  const styles = {
    crimson: "bg-[#9E1B32] text-white hover:bg-[#801225] hover:shadow-[0_0_0_1px_#D4AF37,0_12px_40px_-12px_rgba(158,27,50,0.6)]",
    outline: "border border-[#0D9488]/40 text-[#0D9488] hover:border-[#D4AF37]",
    light: "border border-white/30 text-white hover:border-[#D4AF37]",
  }[variant];
  const inner = (
    <>
      <span>{children}</span>
      <span className="inline-block transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden>→</span>
    </>
  );
  if (type) {
    return (
      <button type={type} onClick={onClick} disabled={disabled} data-testid={testId} className={`${base} ${styles} disabled:opacity-60`}>
        {inner}
      </button>
    );
  }
  if (href) {
    return (
      <a href={href} data-testid={testId} className={`${base} ${styles}`}>
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className={`${base} ${styles}`}>
      {inner}
    </Link>
  );
};
